import React, { FC, useEffect } from 'react';
import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { StrategyDetails } from '@app/types/plugins';
import { getStrategyAcronim } from '@app/helpers/vaults';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { IDerivedLiquidityByGammaInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedGammaMintInfo';
import { Vault } from '@app/hooks/plugins/useVaults';

interface Props {
  mintInfo: IDerivedLiquidityByGammaInfo;
}

export const StrategySelector: FC<Props> = ({ mintInfo }) => {
  const {
    actions: { setStrategy },
    strategy,
    mode
  } = useLiquidityWizardState();

  useEffect(() => {
    if (mintInfo?.pairVaults?.length && !strategy) {
      setStrategy(mintInfo.pairVaults[0]?.id ?? null);
    }
  }, [setStrategy, mintInfo.pairVaults, strategy]);

  function renderViewButton(label: string, _view: Vault) {
    const isActive = _view.id === strategy;

    return (
      <Button
        key={_view.id}
        variant="tertiary"
        width="fit-content"
        px={10}
        onClick={() => setStrategy(_view.id ?? null)}
        sx={{
          fontSize: 14,
          color: isActive ? 'orange' : 'gray.4',
          bg: isActive ? 'gray.2' : 'transparent',
          textTransform: 'capitalize'
        }}
      >
        {getStrategyAcronim(label)}
      </Button>
    );
  }

  if (mode === 'manual' || !mintInfo?.pairVaults?.length) {
    return null;
  }

  return (
    <VStack w="100%" gap={4}>
      <HStack
        bg="gray.2"
        borderRadius={4}
        w="100%"
        justifyContent="space-between"
        p={4}
      >
        <Text fontSize={16}>Select a strategy</Text>
        <CheckIcon color="success" width={4} height={4} />
      </HStack>
      <HStack
        width="100%"
        sx={{
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'gray.5',
          padding: '6px',
          maxWidth: '595px',
          flexWrap: 'wrap'
        }}
      >
        {mintInfo.pairVaults?.map((strategy: Vault) =>
          renderViewButton(strategy.name, strategy)
        )}
      </HStack>
    </VStack>
  );
};
